import axios from "axios";
import {BASE_URL} from "./url_config.js";
const getUserRoles= async (token,user_id)=>{
    console.log("welcome in getUserRoles("+token+","+user_id+")")
    try{
        const headers= {
            "Authorization":`Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        const url=BASE_URL+'/home/getUserRoles?user_id='+user_id
        console.log(url)
        console.log(headers)
        const result= await axios.get(url,  {headers: headers})
        // console.log("result.data din axios in getStationPortChatMessages")
        // console.log(result)
        // console.log(result.data)
        return result.data
    }catch{
        console.log("alerta de eroare la autentificare get getUserRoles din useGetUserRoles")
        return {error:true,message:"invalid data"}
    }
}

const useGetUserRoles=()=>{
    return {getUserRoles}
}

export  default  useGetUserRoles
